import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSqPrefillPreferenceMutationVariables = Types.Exact<{
    input: Types.UpdateAutoApplyInput;
}>;

export type UpdateSqPrefillPreferenceMutation = {
    __typename?: 'Mutation';
    updateAutoApply: {
        __typename?: 'UpdateAutoApplyPayload';
        sqPastAnswerPrefillPreference?: Types.SqPastAnswerPrefillPreference | null | undefined;
    };
};

export const UpdateSqPrefillPreferenceDocument = gql`
    mutation UpdateSqPrefillPreference($input: UpdateAutoApplyInput!) {
        updateAutoApply(input: $input) {
            sqPastAnswerPrefillPreference
        }
    }
`;
export type UpdateSqPrefillPreferenceMutationFn = Apollo.MutationFunction<
    UpdateSqPrefillPreferenceMutation,
    UpdateSqPrefillPreferenceMutationVariables
>;

/**
 * __useUpdateSqPrefillPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateSqPrefillPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSqPrefillPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSqPrefillPreferenceMutation, { data, loading, error }] = useUpdateSqPrefillPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSqPrefillPreferenceMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateSqPrefillPreferenceMutation,
        UpdateSqPrefillPreferenceMutationVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateSqPrefillPreferenceMutation,
        UpdateSqPrefillPreferenceMutationVariables
    >(UpdateSqPrefillPreferenceDocument, options);
}
export type UpdateSqPrefillPreferenceMutationHookResult = ReturnType<
    typeof useUpdateSqPrefillPreferenceMutation
>;
export type UpdateSqPrefillPreferenceMutationResult =
    Apollo.MutationResult<UpdateSqPrefillPreferenceMutation>;
export type UpdateSqPrefillPreferenceMutationOptions = Apollo.BaseMutationOptions<
    UpdateSqPrefillPreferenceMutation,
    UpdateSqPrefillPreferenceMutationVariables
>;
